/**
 * Feature Flags for The Godfrey Method
 *
 * Controls which features are enabled/disabled
 */

export const FEATURE_FLAGS = {
	USE_V2_ONBOARDING: false, // Toggle between V1 and V2 onboarding
	ENABLE_LINK_IN_BIO: true // Toggle Link-in-Bio feature
};

/**
 * Check if V2 onboarding is enabled
 * Priority:
 * 1. Environment variable
 * 2. LocalStorage override (for testing)
 * 3. Default flag value
 */
export const isV2OnboardingEnabled = () => {
	if (import.meta.env.VITE_USE_V2_ONBOARDING === 'true') {
		return true;
	}

	const override = localStorage.getItem('use_v2_onboarding');
	if (override !== null) {
		return override === 'true';
	}

	return FEATURE_FLAGS.USE_V2_ONBOARDING;
};

/**
 * Check if Link-in-Bio feature is enabled
 * Priority:
 * 1. Environment variable
 * 2. LocalStorage override
 * 3. Default flag value
 */
export const isLinkInBioEnabled = () => {
	if (import.meta.env.VITE_ENABLE_LINK_IN_BIO !== undefined) {
		return import.meta.env.VITE_ENABLE_LINK_IN_BIO === 'true';
	}

	const override = localStorage.getItem('enable_link_in_bio');
	if (override !== null) {
		return override === 'true';
	}

	return FEATURE_FLAGS.ENABLE_LINK_IN_BIO;
};

/**
 * Manually toggle feature flags in browser console
 */
if (typeof window !== 'undefined') {
	window.toggleV2Onboarding = enabled => {
		localStorage.setItem('use_v2_onboarding', enabled ? 'true' : 'false');
		console.log(`V2 Onboarding ${enabled ? 'ENABLED' : 'DISABLED'}. Reload page to apply.`);
	};

	window.toggleLinkInBio = enabled => {
		localStorage.setItem('enable_link_in_bio', enabled ? 'true' : 'false');
		console.log(`Link In Bio ${enabled ? 'ENABLED' : 'DISABLED'}. Reload page to apply.`);
	};
}

/**
 * Get signup route based on feature flag
 */
export const getSignupRoute = () => {
	return isV2OnboardingEnabled() ? '/onboarding/create-profile' : '/SignUp';
};
